<template>
        <b-navbar toggleable="lg" type="dark" variant="info" class="mb-3">
          <b-navbar-brand href="#">Surovital</b-navbar-brand>
  
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
  
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item-dropdown text="Dostawa" left>
                <b-dropdown-item href="#/Dostawa">Nowa Dostawa</b-dropdown-item>
                <b-dropdown-item href="#/PrzyjeteDostawy">Przyjęte dostawy</b-dropdown-item>
                <b-dropdown-item href="#/AktualnyStanMagazynowy">Aktualny stan magazynowy</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown text="Produkcja" left>
                <b-dropdown-item href="#/Mlyny">Młyny</b-dropdown-item>
                <b-dropdown-item href="#/KuwerturyNaPolce">Kuwertury</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown text="Hala produkcyjna" left>
                <b-dropdown-item href="#/Bebny">Bębny</b-dropdown-item>
                <b-dropdown-item href="#/Temperowki">Temperówki</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item href='#/OblewaneProdukt/Wszystkie'>Produkty</b-nav-item>
              <b-nav-item-dropdown text="Magazyn" left>
                <b-dropdown-item href="#/Magazyn">Produkty na magazynie</b-dropdown-item>
                <b-dropdown-item href="#/ListaZamowien">Formularze zamówień</b-dropdown-item>
                <b-dropdown-item href="#/WydaneTowary">Wydania</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item href="#/Administracja">Administracja</b-nav-item>
            </b-navbar-nav>
  
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item href="#/Logowanie" v-if="!isLogged"> Zaloguj się</b-nav-item>
              <b-nav-item @click="logout" v-if="isLogged"> Wyloguj się</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
  </template>
  
  <script>
  export default {
    name: 'NavigationBar',
    computed: {
      isLogged() {
        var store = this.$store;
        var isLoggedIn = store.getters.isLoggedIn;
        return isLoggedIn;
      },
    },
    methods: {
      logout() {
        this.$store.commit('logout');
        this.$router.push('/');
      },
    },
  };
  </script>
